<template>

  <div>    

    <div class="ui large breadcrumb">
      <a v-if="closeTab" class="clickable" @click="onExit()">
        <i class="reply icon m-r-5"></i>Sair
      </a>
      <router-link v-else to="/quotations" class="section">
        <i class="reply icon m-r-5"></i>Orçamentos
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="section"><i class="info circle icon"></i>{{ quotationId }}</div>
      <span v-if="quotation" class="animated fadeIn">
        <i class="right chevron icon divider"></i>
        <div class="section">
          <i class="icon" :class="quotation.statusData.icon + ' ' + quotation.statusData.color"></i> 
          {{ quotation.statusData.description }}
          <span v-if="!quotation.canEdit" class="ui small label"><i class="lock red icon"></i> Bloqueado para alterações</span>
        </div>
      </span>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-if="!loading && quotation" class="animated fadeIn">

      <action-buttons ref="actionButtons" :quotation="quotation" :performingAction="performingAction" @onAction="onAction" />

      <div class="m-t-10">
        <horizontal-tabs :tabs="tabs" @onSelectTab="onSelectTab" />
      </div>

      <div class="ui basic segment no-padding no-margin tabs-container">

        <overview-tab v-if="activeTab == 'overview'" :quotation="quotation" :loadingMessages="loadingMessages"  
          @onNewMessage="onNewMessage()" />

        <customer-tab v-if="activeTab == 'customer'" :customer="quotation.customer" />

        <delivery-tab v-if="activeTab == 'delivery'" :quotation="quotation" />

        <payment-tab v-if="activeTab == 'payment'" :quotation="quotation" />

        <products-tab v-if="activeTab == 'products'" :quotation="quotation" 
          @onBatchPriceUpdate="loadQuotation({ silent: true, refreshItems: true })"
          @onBatchApproval="loadQuotation({ silent: true, refreshItems: true })"          
          @onPricesApproval="loadQuotation({ silent: true })" />

        <info-tab v-if="activeTab == 'info'" :quotation="quotation" />

        <!--<messages-tab v-if="activeTab == 'messages'" :quotation="quotation" :loadingMessages="loadingMessages"
          @onNewMessage="onNewMessage()" />

        <revisions-tab v-if="activeTab == 'revisions'" :quotation="quotation" />

        <documents-tab v-if="activeTab == 'documents'" :quotation="quotation" />

        <processing-tab v-if="activeTab == 'processing'" :quotation="quotation" />

        <attachments-tab v-show="activeTab == 'attachments'" :quotation="quotation" 
          @onUpload="loadMessages()" @onRemove="loadMessages()" /> -->

      </div>

    </div>

    <!--<new-message-dialog ref="messageDialog" :quotation="quotation" @onSendMessage="loadMessages()" />
    
    <update-customer-dialog ref="updateCustomerDialog" :quotation="quotation" @onSelectCustomer="updateCustomer" />
    
    <confirm-dialog ref="confirmDialog" :quotation="quotation" @onConfirm="onConfirm" />
    
    <approve-dialog ref="approveDialog" :quotation="quotation" @onApprove="performAction('approve')" />

    <disapprove-dialog ref="disapproveDialog" :quotation="quotation" @onDisapprove="performAction('disapprove')" />

    <cancel-dialog ref="cancelDialog" :quotation="quotation" @onCancel="onCancel" />

    <delete-dialog ref="deleteDialog" :quotation="quotation" @onDelete="performAction('delete')" />-->

  </div>

</template>

<script>

  import HorizontalTabs from "@/components/horizontal-tabs.vue"
  import ActionButtons from "./action-buttons.vue"  
  import OverviewTab from "./overview-tab.vue"
  import CustomerTab from "./customer-tab.vue"
  import DeliveryTab from "./delivery-tab.vue"
  import PaymentTab from "./payment-tab.vue"
  import ProductsTab from "./products-tab.vue"
  import InfoTab from "./info-tab.vue"
  import MessagesTab from "./messages-tab.vue"
  import NewMessageDialog from "./new-message.vue"
  import RevisionsTab from "./revisions-tab.vue"
  import DocumentsTab from "./documents-tab.vue"
  import ProcessingTab from "./processing-tab.vue"
  import AttachmentsTab from "./attachments-tab.vue"
  import UpdateCustomerDialog from "./update-customer-dialog.vue"
  import ConfirmDialog from "./confirm-dialog.vue"
  import ApproveDialog from "./approve-dialog.vue"
  import DisapproveDialog from "./disapprove-dialog.vue"
  import CancelDialog from "./cancel-dialog.vue"
  import DeleteDialog from "./delete-dialog.vue"
  import { CustomerService, MessageService, QuotationService } from "@/services"
  import { Loader, Message } from "@/utils"

  export default {

    data() {
      return {
        loading: true,
        loadingMessages: false,
        performingAction: "",
        closeTab: false,
        revision: null,
        activeTab: "overview",
        quotationId: "",        
        quotation: null,
        tabs: [],
      }
    },

    components: {
      ActionButtons,
      HorizontalTabs,
      OverviewTab,
      CustomerTab,
      DeliveryTab,
      PaymentTab,
      ProductsTab,
      InfoTab,
      MessagesTab,      
      NewMessageDialog,
      RevisionsTab,
      DocumentsTab,
      ProcessingTab,
      AttachmentsTab,
      UpdateCustomerDialog,
      ConfirmDialog,
      ApproveDialog,
      DisapproveDialog,
      CancelDialog,
      DeleteDialog,
    },

    created() {

      this.quotationId = this.$route.params.id
      this.revision = this.$route.params.rev
      this.closeTab = (this.$route.query.closeTab == "true")

      this.loadQuotation()
    },     

    methods: {

      async loadQuotation(data) {

        if (!data)
          data = { silent: false }

        if (!data.silent)
          this.loading = true

        try {

          if (this.quotation && data.refreshItems)
            this.quotation.items = []

          if (this.revision <= 1) {
            window.close()  
          }

          this.quotation = await QuotationService.getByIdDif(this.quotationId, this.revision)

          this.updateTabs()
          
          await this.loadMessages()

          QuotationService.updateStore(this.quotation)

          if (!data.silent) {
            this.activeTab = "overview" 
            this.loading = false          
          }  
          
        } catch (error) {          
          this.$errorHandler(error)
        }
      },

      updateTabs() {

        this.tabs = [
          { id: "overview", label: "Visão Geral" },
          { id: "customer", label: "Cliente" },
          { id: "delivery", label: "Entrega" },
          { id: "payment", label: "Pagamento" },
          { id: "products", label: "Produtos" },
          { id: "info", label: "Outras Inf." },                 
        ]

        if (!this.quotation.isRevision) {
          this.tabs.push({ id: "messages", label: "Mensagens" })
          this.tabs.push({ id: "revisions", label: "Revisões" })
          this.tabs.push({ id: "documents", label: "Documentos" })
          this.tabs.push({ id: "processing", label: "Processamento" })
          this.tabs.push({ id: "attachments", label: "Anexos" })
        }
      },

      async loadMessages() {

        this.loadingMessages = true

        try {

          this.quotation.messages = await MessageService.findByQuotation(this.quotationId)

          this.loadingMessages = false

        } catch (error) {

          this.loadingMessages = false

          this.$errorHandler(error)
        }
      },

      onExit() {
        window.close()
      },

      onSelectTab(id) {
        this.activeTab = id
      },

      onAction(action) {

        if (action == "update") {

          this.$router.push(`/quotations/form/${this.quotationId}`)

        } else if (action == "confirm") {

          if (CustomerService.isDefaultCustomer(this.quotation.customer)) {
            this.$refs.updateCustomerDialog.show(this.quotation)
          } else {
            this.$refs.confirmDialog.show()
          }
        
        } else if ( action == "transpadrao" ) {
          if (CustomerService.isDefaultCustomer(this.quotation.customer)){
            this.$refs.updateCustomerDialog.show(this.quotation, false)
          } else {
            Message.info("Opção permitida apenas quando cliente padrão")
          }
        } else if (action == "approve") {

          this.$refs.approveDialog.show()
        
        } else if (action == "disapprove") {

          this.$refs.disapproveDialog.show()
        
        } else if (action == "cancel") {

          this.$refs.cancelDialog.show()
        
        } else if (action == "delete") {

          this.$refs.deleteDialog.show()  

        } else {

          this.performAction(action)
        } 
      },

      async performAction(action) {

        let reload = true

        this.performingAction = action

        Loader.show()

        try {

          if (action == "finish") {

            await QuotationService.finishMaintenance(this.quotationId)

          } else if (action == "take_approval") {

            await QuotationService.takeApproval(this.quotationId)

          } else if (action == "giveup") {

            await QuotationService.giveupApproval(this.quotationId)

          } else if (action == "approve") {

            await QuotationService.approve(this.quotationId) 
            
          } else if (action == "disapprove") {

            await QuotationService.disapprove(this.quotationId)   

          } else if (action == "undo") {

            await QuotationService.undoApproval(this.quotationId)     

          } else if (action == "technical_approval") {

            await QuotationService.requestTecnicalApproval(this.quotationId)       
          
          } else if (action == "delete") {

            await QuotationService.delete(this.quotationId)         

          } else if (action == "lock") {

            await QuotationService.lockUpdate(this.quotationId)

            Message.info("O responsável não poderá mais realizar alterações que demandem novas aprovações")
          
          } else if (action == "unlock") {

            await QuotationService.unlockUpdate(this.quotationId)

            Message.info("O responsável poderá realizar alterações que demandem novas aprovações")
          
          } else if (action == "print") {

            reload = false

            await QuotationService.print(this.quotationId, this.revision)
            
          }
          
        } catch (error) {                  

          this.$errorHandler(error)
        }        

        if (action == "delete") {

          QuotationService.removeFromStore(this.quotationId)

          Message.info("Orçamento excluído com sucesso")

          this.$router.push("/quotations")

        } else if (reload) {

          await this.loadQuotation()

          QuotationService.updateStore(this.quotation)

        }

        this.performingAction = ""

        Loader.hide()
      },

      onNewMessage() {
        this.$refs.messageDialog.show()
      },      

      async updateCustomer(customer, final=true) {

        Loader.show()

        try {

          await QuotationService.updateCustomer({
            quotationId: this.quotationId,
            codeCustomer: customer.code,
            unitCustomer: customer.unit,
          })

          await this.loadQuotation()

          QuotationService.updateStore(this.quotation)

          Loader.hide()
          
          if (final) {
            setTimeout(() => this.$refs.confirmDialog.show(), 800)
          }
          
        } catch (error) {
          
          Loader.hide()

          this.$errorHandler(error)
        }
      },

      async onConfirm() {

        Loader.show()

        try {

          await this.loadQuotation()

          QuotationService.updateStore(this.quotation)

          Loader.hide()

          Message.success("Orçamento confirmado com sucesso")

        } catch (error) {

          Loader.hide()

          this.$errorHandler(error)
        }
      },

      async onCancel(data) {

        Loader.show()

        try {

          await QuotationService.cancel({ quotationId: this.quotationId, ...data })

          await this.loadQuotation()

          QuotationService.updateStore(this.quotation)

          Loader.hide()

          Message.success("Orçamento cancelado com sucesso")

        } catch (error) {

          Loader.hide()

          this.$errorHandler(error)
        }
      },
    },
  }

</script>
